<div class="loading-full-colibri">
    <app-navbar [showStartOver]="false" [status]="96"
            [showShortIcon]="true" [showSkyPriority]="false"
            [showLanguagesButton]="false"></app-navbar>
    <div class="content bg-am-premium-blue">
        <img src="./assets/images/loading_full.gif">
    </div>
</div>